import React from "react";
import { ContentLayout, DeleteModal, HeaderBreadcrumbs } from "../../../shared";
import { Button, Avatar, Box } from "@mui/material";
import { useParams } from "react-router-dom";
import { useCategory } from "../hooks";
import {
  CategoryGeneralDetails,
  CategoryProductsDetails,
} from "../components";

export const CategoryDetails = () => {
  const { id } = useParams();
  const {
    state,
    toggleModal,
    handleDeleteCategory,
    isEditable,
    isDeletable,
    setCurentTab: setCurrentTab,
    onCategoryProductOrderChange,
    onSaveCategoryProductOrderChange,
  } = useCategory({
    isCategory: false,
    categoryId: id,
    isProduct: false,
  });

  const breadcrumbs = [
    { name: "Dashboard", href: "/" },
    { name: "Category", href: "/category" },
    { name: state.name },
  ];

  const isActive = state.data?.status === 1 ? "Active" : "Inactive";

  const tabs = React.useMemo(
    () => [
      {
        label: "Details",
        value: "1",
        panel: (
          <CategoryGeneralDetails
            state={state}
            isEditable={isEditable}
            id={id}
          />
        ),
      },
      {
        label: "Products",
        value: "2",
        panel: (
          <CategoryProductsDetails
            state={state}
            onCategoryProductOrderChange={onCategoryProductOrderChange}
            setCurentTab={setCurrentTab}
            onSave={onSaveCategoryProductOrderChange}
          />
        ),
      },
      // {
      //   label: "SEO",
      //   value: "3",
      //   panel: <CategorySeoDetails categoryDetails={state} />,
      // },
    ],
    [state],
  );

  return (
    <ContentLayout
      title={state.name}
      active={isActive}
      breadcrumbs={<HeaderBreadcrumbs links={breadcrumbs} />}
      backImage={
        <Avatar
          sx={{
            backgroundColor: state.data?.color,
            width: "80px",
            height: "80px",
          }}
        >
          <Box
            component="img"
            width="37px"
            height="25px"
            alt="details avatar"
            src={state.data.icon}
            className="details-avater-img"
          />
        </Avatar>
      }
      rightContent={
        isDeletable && (
          <Button
            aria-label="delete"
            color="primary"
            type="button"
            size="medium"
            variant="text"
            className="delte"
            disabled={state.data.product_count > 0}
            onClick={() => toggleModal(id, "detaials")}
            sx={{
              minWidth: "40px",
              p: "8px",
            }}
          >
            <Box
              component="img"
              className={state.data.product_count > 0 && "img-disabled "}
              src="/icons/ic_delete_blue.svg"
            />
          </Button>
        )
      }
      tabProps={{
        label: "categoryDetails",
        list: tabs,
      }}
    >
      <DeleteModal
        open={state.isOpen}
        handleClose={() => toggleModal(null, "details")}
        onConfirm={() => {
          handleDeleteCategory("details");
        }}
      />
    </ContentLayout>
  );
};
